import React from 'react';

class Loader extends React.Component{
    render() {
        return (
            <div className="loader">
                <img src="/images/loader.svg" alt="Loading..."/>
                <span>Loading</span>
            </div>
        );
    }
}

export default Loader;


/** WEBPACK FOOTER **
 ** ./src/components/ui/Loader.js
 **/